<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaEventFields"
        title-table="Campos de Evento"
        module="eventFieldSettingsModule"
        sort-name="id"
        :show-btn-add="verificarPermissao('ROLE_CORE_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_CORE_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <EventFieldForm v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import { verificarPermissao } from '@/auth/utils'
import EventFieldForm from './form/EventFieldForm.vue'

export default {
  name: 'EventFieldSetting',
  components: {
    BRow,
    BCol,
    TableComponents,
    EventFieldForm,
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: 'ID',
          field: 'id',
          width: '80px',
        },
        {
          label: 'Evento',
          field: 'evento.nome',
        },
        {
          label: 'Campo',
          field: 'campo.nome',
        },
        {
          label: 'Valor',
          field: 'valor',
        },
        {
          label: 'Ativo',
          field: 'ativo',
          formatter(value) { return value ? 'Sim' : 'Não' },
          width: '80px',
        },
      ],
    };
  },
  computed: {
    ...mapState('eventFieldSettingsModule', {
      listaEventFields: (state) => state.listaEventFields,
    }),
  },
  methods: {
    addNew() {
      this.$store.dispatch('eventFieldSettingsModule/reset');
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch('eventFieldSettingsModule/prepareToEdit', data);
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
      this.$store.dispatch('eventFieldSettingsModule/reset');
    },
  },
};
</script>
